import React from 'react';

import { formatBs, pricing } from '../data';
import { useLanguage } from '../i18n';
import IphoneMap from '../assets/ronda/iphone-map.webp';

const Pricing = () => {
  const { lang, t } = useLanguage();
  const copy = t.pricing;
  const exampleTotal = pricing.unlock + pricing.perMinute * pricing.exampleMinutes;

  return (
    <section id='pricing' className='pb-20 lg:pb-28'>
      <div className='container'>
        <div
          data-nav-on='dark'
          className='grid items-center gap-10 rounded-panel bg-ronda px-6 py-10 text-canvas sm:px-10 sm:py-14 lg:grid-cols-[1fr_auto] lg:gap-16 lg:px-16 lg:py-14'
        >
          <div className='flex flex-col'>
            <p className='eyebrow text-ronda-mint'>{copy.eyebrow}</p>
            <h2 className='title mt-4 text-canvas'>{copy.title}</h2>
            <p className='mt-5 max-w-[420px] text-lg leading-relaxed text-canvas/80'>
              {copy.text}
            </p>

            <dl className='mt-8 grid grid-cols-2 gap-3'>
              <div className='flex flex-col rounded-[24px] bg-canvas/[0.08] p-3 sm:p-6'>
                <dt className='flex-1 text-[15px] text-canvas/80'>{copy.unlock}</dt>
                <dd className='mt-2 font-display text-[44px] font-semibold leading-none tracking-display sm:text-[56px]'>
                  Bs {formatBs(pricing.unlock, lang)}
                </dd>
              </div>
              <div className='flex flex-col rounded-[24px] bg-canvas/[0.08] p-3 sm:p-6'>
                <dt className='flex-1 text-[15px] text-canvas/80'>{copy.perMinute}</dt>
                <dd className='mt-2 font-display text-[44px] font-semibold leading-none tracking-display sm:text-[56px]'>
                  Bs {formatBs(pricing.perMinute, lang)}
                </dd>
              </div>
            </dl>
            <p className='mt-5 text-[15px] text-canvas/75'>
              {copy.example(pricing.exampleMinutes)}{' '}
              <span className='font-semibold text-canvas'>Bs {formatBs(exampleTotal, lang)}</span>.
            </p>
          </div>

          <img
            src={IphoneMap}
            alt={copy.imageAlt}
            loading='lazy'
            width='681'
            height='1321'
            className='mx-auto h-auto w-full max-w-[260px] sm:max-w-[300px] lg:mx-0 lg:mr-8'
          />
        </div>
      </div>
    </section>
  );
};

export default Pricing;
